import { render, staticRenderFns } from "./DigitalProduct.vue?vue&type=template&id=793e7a03&scoped=true&"
import script from "./DigitalProduct.vue?vue&type=script&lang=js&"
export * from "./DigitalProduct.vue?vue&type=script&lang=js&"
import style0 from "./DigitalProduct.vue?vue&type=style&index=0&id=793e7a03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793e7a03",
  null
  
)

export default component.exports